"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Tour = _interopRequireDefault(require("./Tour"));
var _default = _Tour.default;
exports.default = _default;